import React from 'react';

function SelectedPromoCodeMessageTemplate ({ helpers }) {

	const { displySuccessFullPromoCodeMessage } = helpers;

	if (displySuccessFullPromoCodeMessage) {

		return <>A coupon code has been applied to your cart</>;

	}
	return null;

}

export default SelectedPromoCodeMessageTemplate;
